<template>
  <div v-loading="loading">
    <div class="qrCodeDiv">
      <div>
        <p style="font-size: 18px">Android</p>
        <canvas id="QRCode_Android_Download2" style="width: 280px; height: 280px"></canvas>
      </div>
      <div>
        <p style="font-size: 18px">IOS</p>
        <canvas id="QRCode_IOS_Download2" style="width: 280px; height: 280px"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadTimes } from "@/api/home";
import QRCode from "qrcode";
import { mapGetters } from "vuex";

export default {
  name: "DownloadApp",
  data() {
    return {
      iosOrAn: '',
      BaseUrl: '',
      And_url: '',
      Ios_url: '',
      loading: false,
      show: 1
    }
  },
  computed: {
    ...mapGetters([
      'shoppingList',
      'language',
      'userCode',
      'token',
      'ckCode',
      'username',
      'isAgent',
      'permissions',
      'permission_routes',
      'companyCode'
    ]),
  },
  async created() {
    if (this.language === 'zh_CN') {
      this.show = 1
    } else {
      this.show = 2
    }
    this.loading = true
    this.Ios_url = await this.getDownloadUrl('IOS')
    this.createQrCode(this.Ios_url, 'QRCode_IOS_Download2')
    this.loading = false
  },
  mounted() {
    this.BaseUrl = window.location.href.split('#')[0] + '#/downloadapp?type=Android'
    this.createQrCode(this.BaseUrl, 'QRCode_Android_Download2')
  },
  watch: {
    "language": function (newVal, oldVal) {
      console.log("新值", newVal);
      console.log("旧值", oldVal);
      if (newVal === 'zh_CN') {
        this.show = 1
      } else {
        this.show = 2
      }
    },
    $route: {
      handler: async function (route) {
        const query = route.query
        if (query.type === 'Android') {
          this.And_url = await this.getDownloadUrl('Android')
          let a = document.createElement('a')
          a.href = this.And_url
          a.click();
        }
      },
      immediate: true
    },
  },
  methods: {
    createQrCode(qrUrl, domId) {
      let opts = {
        errorCorrectionLevel: "H", //容错级别
        type: "image/png", //生成的二维码类型
        quality: 0.3, //二维码质量
        margin: 0, //二维码留白边距
        width: 280, //宽
        height: 280, //高
        text: "http://www.xxx.com", //二维码内容
        color: {
          dark: "#333333", //前景色
          light: "#fff", //背景色
        },
      };

      let msg = document.getElementById(domId);
      // 将获取到的数据(val)画到msg(canvas)上
      QRCode.toCanvas(msg, qrUrl, opts, function (error) {
        if (error) {
          console.log("二维码加载失败", error);
          this.$message.error("二维码加载失败");
        }
      })
    },
    getDownloadUrl(type) {
      return new Promise((resolve, reject) => {
        uploadTimes({ 'iosOrAn': type }).then(res => {
          resolve(res.data)
        }).catch(err => {
          console.warn(err)
          reject(err)
        })
      })
    },
  }
}
</script>

<style scoped lang="scss">
.flowdiagram_zh {
  p {
    font-size: 20px;
    //text-align: left;
  }
}

.flowdiagram_rus {
  p {
    font-size: 20px;
    //text-align: left;
  }
}

.qrCodeDiv {
  display: flex;
  flex-direction: row;
  justify-content: space-around
}

@media only screen and (max-width: 750px) {
  .qrCodeDiv {
    display: flex;
    flex-direction: column;
  }
}
</style>
